import { BASE_PATH as l, BaseAPI as V, operationServerMap as m } from "../base.js";
import { DUMMY_BASE_URL as R, assertParamExists as g, createRequestFunction as u, serializeDataIfNeeded as P, setSearchParams as p, toPathString as v } from "../common.js";
import G from "axios";
var S = function(t) {
  return {
    merchantCreditChangeRecordCreateCreditChangeRecord: async (n, d = {}) => {
      g("merchantCreditChangeRecordCreateCreditChangeRecord", "creditChangeRecordDTO", n);
      const o = new URL("/merchant/mms/credit_change_record", R);
      let r;
      t && (r = t.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...d
      }, a = {}, c = {};
      a["Content-Type"] = "application/json", p(o, c);
      let s = r && r.headers ? r.headers : {};
      return e.headers = {
        ...a,
        ...s,
        ...d.headers
      }, e.data = P(n, e, t), {
        url: v(o),
        options: e
      };
    },
    merchantCreditChangeRecordGetCreditChangeRecordPage: async (n, d = {}) => {
      g("merchantCreditChangeRecordGetCreditChangeRecordPage", "creditChangeUserPageRequestDTO", n);
      const o = new URL("/merchant/mms/credit_change_record/page", R);
      let r;
      t && (r = t.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...d
      }, a = {}, c = {};
      a["Content-Type"] = "application/json", p(o, c);
      let s = r && r.headers ? r.headers : {};
      return e.headers = {
        ...a,
        ...s,
        ...d.headers
      }, e.data = P(n, e, t), {
        url: v(o),
        options: e
      };
    },
    merchantCreditChangeRecordGetCreditGetRecordsPage: async (n, d = {}) => {
      g("merchantCreditChangeRecordGetCreditGetRecordsPage", "creditGetRecordsUserPageRequestDTO", n);
      const o = new URL("/merchant/mms/credit_change_record/get_records/page", R);
      let r;
      t && (r = t.baseOptions);
      const e = {
        method: "POST",
        ...r,
        ...d
      }, a = {}, c = {};
      a["Content-Type"] = "application/json", p(o, c);
      let s = r && r.headers ? r.headers : {};
      return e.headers = {
        ...a,
        ...s,
        ...d.headers
      }, e.data = P(n, e, t), {
        url: v(o),
        options: e
      };
    },
    merchantCreditChangeRecordGetCustomerCreditChangeRecords: async (n, d, o = {}) => {
      g("merchantCreditChangeRecordGetCustomerCreditChangeRecords", "customerUserId", n);
      const r = "/merchant/mms/credit_change_record/customer/{customerUserId}".replace("{customerUserId}", encodeURIComponent(String(n))), e = new URL(r, R);
      let a;
      t && (a = t.baseOptions);
      const c = {
        method: "GET",
        ...a,
        ...o
      }, s = {}, C = {};
      d !== void 0 && (C.changeType = d), p(e, C);
      let h = a && a.headers ? a.headers : {};
      return c.headers = {
        ...s,
        ...h,
        ...o.headers
      }, {
        url: v(e),
        options: c
      };
    },
    merchantCreditChangeRecordGetCustomerCreditStatistics: async (n, d = {}) => {
      g("merchantCreditChangeRecordGetCustomerCreditStatistics", "customerUserId", n);
      const o = "/merchant/mms/credit_change_record/customer/{customerUserId}/statistics".replace("{customerUserId}", encodeURIComponent(String(n))), r = new URL(o, R);
      let e;
      t && (e = t.baseOptions);
      const a = {
        method: "GET",
        ...e,
        ...d
      }, c = {};
      p(r, {});
      let s = e && e.headers ? e.headers : {};
      return a.headers = {
        ...c,
        ...s,
        ...d.headers
      }, {
        url: v(r),
        options: a
      };
    }
  };
}, i = function(t) {
  const n = S(t);
  return {
    async merchantCreditChangeRecordCreateCreditChangeRecord(d, o) {
      var r, e;
      const a = await n.merchantCreditChangeRecordCreateCreditChangeRecord(d, o), c = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, s = (e = m["MerchantCreditChangeRecordApi.merchantCreditChangeRecordCreateCreditChangeRecord"]) === null || e === void 0 || (e = e[c]) === null || e === void 0 ? void 0 : e.url;
      return (C, h) => u(a, G, l, t)(C, s || h);
    },
    async merchantCreditChangeRecordGetCreditChangeRecordPage(d, o) {
      var r, e;
      const a = await n.merchantCreditChangeRecordGetCreditChangeRecordPage(d, o), c = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, s = (e = m["MerchantCreditChangeRecordApi.merchantCreditChangeRecordGetCreditChangeRecordPage"]) === null || e === void 0 || (e = e[c]) === null || e === void 0 ? void 0 : e.url;
      return (C, h) => u(a, G, l, t)(C, s || h);
    },
    async merchantCreditChangeRecordGetCreditGetRecordsPage(d, o) {
      var r, e;
      const a = await n.merchantCreditChangeRecordGetCreditGetRecordsPage(d, o), c = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, s = (e = m["MerchantCreditChangeRecordApi.merchantCreditChangeRecordGetCreditGetRecordsPage"]) === null || e === void 0 || (e = e[c]) === null || e === void 0 ? void 0 : e.url;
      return (C, h) => u(a, G, l, t)(C, s || h);
    },
    async merchantCreditChangeRecordGetCustomerCreditChangeRecords(d, o, r) {
      var e, a;
      const c = await n.merchantCreditChangeRecordGetCustomerCreditChangeRecords(d, o, r), s = (e = t == null ? void 0 : t.serverIndex) !== null && e !== void 0 ? e : 0, C = (a = m["MerchantCreditChangeRecordApi.merchantCreditChangeRecordGetCustomerCreditChangeRecords"]) === null || a === void 0 || (a = a[s]) === null || a === void 0 ? void 0 : a.url;
      return (h, O) => u(c, G, l, t)(h, C || O);
    },
    async merchantCreditChangeRecordGetCustomerCreditStatistics(d, o) {
      var r, e;
      const a = await n.merchantCreditChangeRecordGetCustomerCreditStatistics(d, o), c = (r = t == null ? void 0 : t.serverIndex) !== null && r !== void 0 ? r : 0, s = (e = m["MerchantCreditChangeRecordApi.merchantCreditChangeRecordGetCustomerCreditStatistics"]) === null || e === void 0 || (e = e[c]) === null || e === void 0 ? void 0 : e.url;
      return (C, h) => u(a, G, l, t)(C, s || h);
    }
  };
}, x = function(t, n, d) {
  const o = i(t);
  return {
    merchantCreditChangeRecordCreateCreditChangeRecord(r, e) {
      return o.merchantCreditChangeRecordCreateCreditChangeRecord(r.creditChangeRecordDTO, e).then((a) => a(d, n));
    },
    merchantCreditChangeRecordGetCreditChangeRecordPage(r, e) {
      return o.merchantCreditChangeRecordGetCreditChangeRecordPage(r.creditChangeUserPageRequestDTO, e).then((a) => a(d, n));
    },
    merchantCreditChangeRecordGetCreditGetRecordsPage(r, e) {
      return o.merchantCreditChangeRecordGetCreditGetRecordsPage(r.creditGetRecordsUserPageRequestDTO, e).then((a) => a(d, n));
    },
    merchantCreditChangeRecordGetCustomerCreditChangeRecords(r, e) {
      return o.merchantCreditChangeRecordGetCustomerCreditChangeRecords(r.customerUserId, r.changeType, e).then((a) => a(d, n));
    },
    merchantCreditChangeRecordGetCustomerCreditStatistics(r, e) {
      return o.merchantCreditChangeRecordGetCustomerCreditStatistics(r.customerUserId, e).then((a) => a(d, n));
    }
  };
}, I = class extends V {
  merchantCreditChangeRecordCreateCreditChangeRecord(t, n) {
    return i(this.configuration).merchantCreditChangeRecordCreateCreditChangeRecord(t.creditChangeRecordDTO, n).then((d) => d(this.axios, this.basePath));
  }
  merchantCreditChangeRecordGetCreditChangeRecordPage(t, n) {
    return i(this.configuration).merchantCreditChangeRecordGetCreditChangeRecordPage(t.creditChangeUserPageRequestDTO, n).then((d) => d(this.axios, this.basePath));
  }
  merchantCreditChangeRecordGetCreditGetRecordsPage(t, n) {
    return i(this.configuration).merchantCreditChangeRecordGetCreditGetRecordsPage(t.creditGetRecordsUserPageRequestDTO, n).then((d) => d(this.axios, this.basePath));
  }
  merchantCreditChangeRecordGetCustomerCreditChangeRecords(t, n) {
    return i(this.configuration).merchantCreditChangeRecordGetCustomerCreditChangeRecords(t.customerUserId, t.changeType, n).then((d) => d(this.axios, this.basePath));
  }
  merchantCreditChangeRecordGetCustomerCreditStatistics(t, n) {
    return i(this.configuration).merchantCreditChangeRecordGetCustomerCreditStatistics(t.customerUserId, n).then((d) => d(this.axios, this.basePath));
  }
};
export {
  I as MerchantCreditChangeRecordApi,
  S as MerchantCreditChangeRecordApiAxiosParamCreator,
  x as MerchantCreditChangeRecordApiFactory,
  i as MerchantCreditChangeRecordApiFp
};

//# sourceMappingURL=merchant-credit-change-record-api.js.map